import { API_URL } from '../config';
import { TStateEnum } from '../models/Tournament';

export interface EnrollmentData {
  tournamentId: number;
  tenantId: number;
  name: string;
  surname: string;
  email: string;
  phone: string;
  teamName: string;
  noOfPlayers: number;
  regulationsAgreed: boolean;
  gdprAgreed: boolean;
  marketingAgreed: boolean;
  password?: string;
  selectedTeamId?: number;
}

export interface EnrollmentDetails {
  name: string;
  offerUrl: string;
  offerDetails: string;
  regulations: string;
  tournamentState: TStateEnum;
}

export const fetchEnrollmentDetails = async (tournamentId: string): Promise<EnrollmentDetails> => {
  const response = await fetch(`${API_URL}/api/enrollment/${tournamentId}/details`, {
    method: 'GET',
    headers: {
      'Content-Type': 'application/json',
    },
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to fetch enrollment details');
  }

  const data: EnrollmentDetails = await response.json();
  return data;
};

export const enroll = async (data: EnrollmentData) => {
  const response = await fetch(`${API_URL}/api/enrollment`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify(data),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to enroll');
  }

  return response.json();
};

export const confirmEnrollment = async (token: string) => {
  const response = await fetch(`${API_URL}/api/enrollment/confirm`, {
    method: 'POST',
    headers: {
      'Content-Type': 'application/json',
    },
    body: JSON.stringify({ token }),
  });

  if (!response.ok) {
    const error = await response.text();
    throw new Error(error || 'Failed to confirm enrollment');
  }

  return response.json();
};
